import React from 'react'
import { Row, Col } from 'antd'
import { Aside, Content } from './overview/style'
import Heading from '../../../components/heading/heading'

const AuthLayout = WraperContent => {
  return () => {
    const topShape = require('../../../static/img/auth/topShape.png')
    const bottomShape = require('../../../static/img/auth/bottomShape.png')
    const logo = require('../../../static/img/logo_pneusystem.png')
    const figure = require('../../../static/img/auth/pneusystem-login-img.png')
    return (
      <Row>
        <Col xxl={8} xl={9} lg={12} md={8} xs={24}>
          <Aside>
            <div className='auth-side-content'>
              <img
                src={topShape?.default || topShape}
                alt=''
                className='topShape'
              />
              <img
                src={bottomShape?.default || bottomShape}
                alt=''
                className='bottomShape'
              />
              <Content>
                <img
                  style={{ width: '150px' }}
                  src={logo?.default || logo}
                  alt=''
                />
                <br />
                <br />
                <Heading as='h1'>
                  sieť partnerských <br />
                  pneuservisov
                </Heading>
                <img
                  className='auth-content-figure'
                  src={figure?.default || figure}
                  alt=''
                />
              </Content>
            </div>
          </Aside>
        </Col>

        <Col xxl={16} xl={15} lg={12} md={16} xs={24}>
          <WraperContent />
        </Col>
      </Row>
    )
  }
}

export default AuthLayout
